"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROITextAreaTheme = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var classnames_1 = __importDefault(require("classnames"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var ROITextAreaTheme;
(function (ROITextAreaTheme) {
    ROITextAreaTheme["Light"] = "light";
    ROITextAreaTheme["Dark"] = "dark";
})(ROITextAreaTheme || (exports.ROITextAreaTheme = ROITextAreaTheme = {}));
var ROITextArea = (function (_super) {
    __extends(ROITextArea, _super);
    function ROITextArea() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.focussed = false;
        _this.handleUpdateFocus = function (value) {
            _this.focussed = value;
        };
        return _this;
    }
    ROITextArea.prototype.render = function () {
        var _this = this;
        var _a = this.props, onChange = _a.onChange, placeholder = _a.placeholder, label = _a.label, value = _a.value, centered = _a.centered, className = _a.className, _b = _a.theme, theme = _b === void 0 ? ROITextAreaTheme.Light : _b, disabled = _a.disabled;
        var valueForSpacer = value.charAt(value.length - 1) === "\n" ? react_1.default.createElement(react_1.default.Fragment, null,
            value,
            "\u00A0") : value;
        return (react_1.default.createElement("div", { contentEditable: false, className: (0, classnames_1.default)("roi-textarea__container", className, {
                "roi-textarea__container--centered": !!centered,
            }), "data-interactive-zone": true },
            react_1.default.createElement("div", { className: "roi-textarea__spacer" }, valueForSpacer),
            react_1.default.createElement(kaleidoscope_1.TextInput, { label: label, labelHidden: true, multiline: true, placeholder: placeholder, variant: kaleidoscope_1.TextInputVariant.Borderless, size: kaleidoscope_1.TextInputSize.XSmall, className: (0, classnames_1.default)("roi-textarea", "roi-textarea--".concat(theme), {
                    "roi-textarea--focussed": this.focussed,
                }), value: value, onChange: onChange, onClick: function (e) { return e.stopPropagation(); }, rows: 1, onFocus: function () { return _this.handleUpdateFocus(true); }, onBlur: function () { return _this.handleUpdateFocus(false); }, disabled: disabled })));
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], ROITextArea.prototype, "focussed", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ROITextArea.prototype, "handleUpdateFocus", void 0);
    ROITextArea = __decorate([
        mobx_react_1.observer
    ], ROITextArea);
    return ROITextArea;
}(react_1.default.Component));
exports.default = ROITextArea;
